// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K559dU3hITJS9AfLFEde{color:var(--theme-text-light) !important}.K559dU3hITJS9AfLFEde:hover{text-decoration:none}`, "",{"version":3,"sources":["webpack://./src/components/support/report-paths/report-paths.scss"],"names":[],"mappings":"AAAA,sBACI,wCAAA,CAEA,4BACI,oBAAA","sourcesContent":[".exportButton {\n    color: var(--theme-text-light) !important;\n\n    &:hover {\n        text-decoration: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"exportButton": `K559dU3hITJS9AfLFEde`
};
export default ___CSS_LOADER_EXPORT___;
